<script lang="ts">
	
	import {onMount} from "svelte";
    import Footer from "./components/Footer.svelte";
    import Header from "./components/Header.svelte";
    import Route from "./components/Route.svelte";
    import IntroBis from "./pages/IntroBis.svelte";
	import {app_version, storeDomain, storeIsIntro, storeScreenWidth, storeIsMobile } from './scripts/store';

	onMount(async () => {
		console.log(
			$app_version.app_name + 
			" - version " + $app_version.version);
		storeScreenWidth.set(screen.width);
		if (screen.width > 1024) {
			storeIsMobile.set(false);
		} else {
			storeIsMobile.set(true);
		}
		storeDomain.subscribe((data) => {
			if (data == "services") {
				document.body.style.background = "#00007A";
			} else if (data == "amenagements") {
				document.body.style.background = "#7B1622";
			} else {
				document.body.style.background = "#00007A";
			}
		})
	});

</script>

<style lang="scss">

	:global(body) {
		padding: 0;
		margin: 0;
		min-height: 100%;
		height: 100%;
		background-color: $color-bleu-instit;
		color: $color-white;
	}

	:global(html) {
		padding: 0;
		margin: 0;
		overflow: scroll;
		min-height: 100%;
		height: 100%;
		overflow-x: hidden;
	}

	.contener {
		display: grid;
		grid-template-columns: 1fr;
		padding: 0 $contener-marge-small 0 $contener-marge-small;
		column-gap: 30px;
		justify-content: flex-start;
		align-content: center;
		margin: auto;
		overflow: hidden;
	}

	@include large {
		.contener {
			padding: 0 $contener-marge-large 0 $contener-marge-large;
		}
	}

	@include extra-large {
		.contener {
			max-width: 1200px;
		}
	}

</style>

{#if ($storeIsIntro)}
<IntroBis />
{:else}
<div class="body" class:body__services={$storeDomain == "services"} class:body__amenagements={$storeDomain == "amenagements"}>
	<div class="contener font-txt-courant">
		<Header />
		<Route />
		<Footer />
	</div>	
</div>
{/if}